//
// AssociatedRegion.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "../BIRDModel";
import "./RegionType";

var AssociatedRegion = createModule("BIRD::AssociatedRegion", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel"], EventDispatcher, [
    ,
    {
        regionTypeLabel: 7,
        regionDisplay: 7,
        regionId: 7,
        regionType: 4,
        name: 7,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default AssociatedRegion;
